import React from "react";
import { Modal as AntdModal } from "antd";
import "./Modal.scss";

interface ModalProps {
  title?: React.ReactNode | string;
  children: React.ReactNode;
  width: string | number;
  visible: boolean;
  onCancel?: () => void;
  afterClose?: () => void;
}

const Modal = (props: ModalProps) => {
  const { title, children, width, visible, onCancel, afterClose } = props;
  return (
    <AntdModal
      title={title}
      visible={visible}
      onCancel={onCancel}
      afterClose={afterClose}
      footer={null}
      width={width}
    >
      {children}
    </AntdModal>
  );
};

export default Modal;
